<nz-layout class="h-100">
  <!-- ENCABEZADO -->
  <nz-page-header [nzTitle]="!(isMobile$ | async) ? titleTmpl : undefined">
    <ng-template #titleTmpl>
      <!-- Titulo de la seccion (Desktop) -->
      <div class="flex gap-200">
        <app-st-icon class="text-header-24" [style.background-color]="bgColor || '#fff'"
                     [class.adjust-padding-bot]="adjustPaddingBot"
                     [color]="color" [name]="icon" [bold]="true"></app-st-icon>
        <h1 class="text-header-24">{{title}}</h1>

        @if (isAdministrationView) {
          <div class="flex-center gap-200" >
            <nz-divider nzType="vertical"></nz-divider>
            <nz-segmented [nzOptions]="['Ver órdenes', 'Ver estados de pago', 'Ver órdenes de compra', 'Ver operaciones analíticas']"
                          [ngModel]="administrationUtilsService.administrationView$ | async"
                          (nzValueChange)="handleSegmentedValueChange($event)"></nz-segmented>
          </div>
        }
      </div>
    </ng-template>

    <nz-page-header-extra>
      <app-global-searchbar [ngClass]="{'hide': (isMobile$ | async) && hideGlobalSearch}"></app-global-searchbar>
    </nz-page-header-extra>
  </nz-page-header>

  <!-- CONTENEDOR PRINCIPAL -->
  <nz-layout class="main-layout" [class.full-width]="fullWidth">
    <!-- Mostrar busqueda y filtros avanzados (Mobile) -->
    @if (showMobileSearchBar) {
      <div class="mobile-search-filter">
        <button (click)="emitPrimaryBtnEvent()" nzShape="circle" nzSize="default" nz-button nzType="text">
          <app-st-icon [bold]="true" name="add"></app-st-icon>
        </button>
        <button (click)="toggleSearch($event)" nzShape="circle" nzSize="default" nz-button nzType="text">
          <app-st-icon [bold]="true" name="search"></app-st-icon>
        </button>
        <button (click)="toggleGlobalSearch($event)" nzShape="circle" nzSize="default" nz-button nzType="text">
          <app-st-icon [bold]="true" name="travel_explore"></app-st-icon>
        </button>
      </div>
    }


    <!-- Filtros y barra de busqueda -->
    @if (!hideFilters) {
      <div class="transition-02 flex-center-between gap-250 filters-btn-wrapper"
           [ngClass]="{'gap-0': (isMobile$ | async) && hideSearch && hideGlobalSearch}">
        <div class="flex gap-100">
          <app-pocket-searchbar style="margin-right: 8px"
                                [class.hide]="(isMobile$ | async) && hideSearch"
                                [(searchValue)]="searchValue"
                                (searchEvent)="emitSearch()"></app-pocket-searchbar>

          <div class="flex-center-between gap-150 no-scroll-bar filter-wrapper">
            @for (filter of filters; track filter) {
              <div (click)="onFilterSelect(filter)" class="st-badget"
                   [ngClass]="filter.active ? (filter.class || 'black') : 'subtle-grey'">
                <app-st-icon [name]="filter.icon"></app-st-icon>
                <label>{{filter.name}}</label>
              </div>
            }
          </div>
        </div>

        @if (showSearchBar || !!primaryBtnLabel) {
          <div class="flex-center-between gap-200">
            <!-- Boton de creado (Desktop) -->
            @if (!!primaryBtnLabel) {
              <button
                      (click)="emitPrimaryBtnEvent()" nzShape="round" nzSize="default" nz-button nzType="primary">
                <app-st-icon class="prefix" name="add"></app-st-icon>
                <span>{{primaryBtnLabel}}</span>
              </button>
            }
          </div>
        }

        <!-- Evento de marcar todas como leidas (Desktop) -->
        @if (isNotification) {
          <button class="flex-center"
                  [ngClass]="{'mobile-mark-all-button':isMobile$}"
                  (click)="emitPrimaryBtnEvent()" nzShape="round" nzSize="large" nz-button nzType="default">
            <app-st-icon class="prefix" name="check_circle"></app-st-icon>
            @if (isMobile$ | async) {
              <span>Marcar todas</span>
            } @else {
              <span>Marcar todas como leídas</span>
            }
          </button>
        }
      </div>
    }

    <!-- CONTENIDO -->
    <nz-content>
      <ng-content></ng-content>
    </nz-content>
  </nz-layout>
</nz-layout>



